module.exports = __webpack_public_path__ + "static/media/EventFlow.cd5d6f9d.jpg";